import axios from "axios";

// will change!!!
export const getCreditInstallments = () => {
  const url = `${window.env.EJ_APPS_API_HOSTNAME}/credit-api/v1/installments`;
  return axios.get(url).then((response) => response.data);
};

export const calculateCredit = (params) => {
  const url = `${window.env.EJ_APPS_API_HOSTNAME}/credit-api/v1/interests/rates`;
  return axios
    .post(
      url,
      {
        application: "desktop-web",
        ...params,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    )
    .then((response) => response.data);
};

export const getHousingCreditCityList = () => {
  const url = `${window.env.EJ_APPS_API_HOSTNAME}/credit-api/v1/locations/cities`;
  return axios.get(url).then((response) => response.data);
};

export const getHousingCreditDistrictList = (city) => {
  const url = `${window.env.EJ_APPS_API_HOSTNAME}/credit-api/v1/locations/districts?city=${city}`;
  return axios.get(url).then((response) => response.data);
};

export const getHousingCreditBranchList = ({ city, district }) => {
  const url = `${window.env.EJ_APPS_API_HOSTNAME}/credit-api/v1/locations?city=${city}&district=${district}`;
  return axios.get(url).then((response) => response.data);
};

export const sendHousingCreditLead = (params) => {
  const url = `${window.env.EJ_APPS_API_HOSTNAME}/credit-api/v1/leads`;
  return axios
    .post(
      url,
      {
        application: "desktop-web",
        ...params,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    )
    .then((response) => response.data);
};
